export default __webpack_public_path__ + "assets/SpaceCenterHouston.41f38223.png";